import { toast } from "react-toastify";
import config from '../../Config/config.json';
import { LogOut, changeLoations } from "../../Redux/Actions/index.js";
import { store } from "../../Redux/Store/index.js";
import { CargosRequests } from "./request.ts";
import i18n from "../../Config/i18n.js";

/**
 * Classe para gerenciamento da página de equipamentos
 */
export class CargosServices {
    constructor() {
        this.requests = new CargosRequests();
        this.Permissions = [];
    }

    // Busca dados do equipamento
    async getCargo(id){
        try {
            const response = await this.requests.getCargo(id);
            this.cargo = response;
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Envia o cargo para ser editado
    async editCargo (Id, cargo){
        try {
            const response = await this.requests.editCargo(Id, cargo);
            toast(i18n.t("message.position-service.response-edit-position"), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Busca todos equipamentos
    async getAllCargos(search, page){
        try {
            const response = await this.requests.getAllCargos(search, page);
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Cria um novo equipamento
    async SaveCargo (cargo){
        try {
            const response = await this.requests.CreateCargo(cargo);
            toast(i18n.t("message.position-service.response-save-position"), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Busca alocações que o usuário pode ver
    async getLocations(){
        try {
            const response = await this.requests.getlocations();
            this.locations = response;
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Busca tipos de alocações que o usuário pode ver
    async getLocationsType(){
        try {
            const response = await this.requests.getlocationsType();
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Muda o tipo de alocações sendo exibido
    ChangeLocationType(type){
        if(type === '6f9d2274-09ed-45d8-96b3-11ee4073da51'){
            store.dispatch(changeLoations([]));
        }else{
            let newtype = type === '153b08f5-3bac-4614-a325-70f2cc84adc7' ? 'Entidades' : type === '941685e4-0fe4-465e-b976-485443cfbb8e' ? 'Grupos' : ''
            store.dispatch(changeLoations(this.locations[newtype]));
        }
    }

    async getAllPermissions(){
        try {
            const response = await this.requests.getAllPermissions();
            let permissoes = await this.verifyPermission(response.data.data, this.cargo.permissions);   
            return permissoes;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    async verifyPermission(allPermissions, cargoPermissions){
        // Cria um conjunto dos IDs do primeiro array
        const ids = new Set(cargoPermissions.map(item => item.id));
        
        // Verifica se algum ID do segundo array está presente no conjunto
        allPermissions.forEach(item => {
            if(ids.has(item.id)){
                item.checked = true;
            }else{
                item.checked = false;
            }
        });
        return allPermissions;
    }

    async addPermission(role, id){
        try {
            const response = await this.requests.addPermission(role, id);
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    async removePermission(role, id){
        try {
            const response = await this.requests.removePermission(role, id);
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }
}